var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"1","y":"4","width":"22","height":"16","rx":"2","key":0}),React.createElement("path",{"d":"M9.474 12.46L2 19m12.483-6.54L22 19m0-13l-10 8L2 6","key":1})]));
}

EmailInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
